export const isIos =
  // @ts-ignore
  /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);

export const isAndroid = !isIos;

export const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
